import { FC, useEffect, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Helmet from '@/components/meta/Helmet';
import SearchRacerConditionTemplate from '@/components/templates/EntryRacer/Condition';
import SearchRacerResultTemplate from '@/components/templates/EntryRacer/Result';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';
import {
  GradeUnitCode,
  SearchEntryRacerInputParam,
  SearchEntryRacerResult,
  useSearchEntryRacerLazyQuery,
} from '@/lib/apollo/types/gen/graphql';
import {
  fromScreenStorage,
  fromScreenUrlStorage,
  searchConditionStorage,
  searchSortStorage,
} from '@/storages/entryRacer/formData';

const SearchEntryRacerPage: FC = () => {
  const pathname = useLocation().pathname;

  const [loadSearchRacer, searchRacerData] = useSearchEntryRacerLazyQuery();
  const [searchResults, setSearchResults] = useState<SearchEntryRacerResult[]>(
    [],
  );
  const [openConditionArea, setOpenConditionArea] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchParam, setSearchParam] = useState<SearchEntryRacerInputParam>();
  const [sortItem, setSortItem] = useState<string>();
  const setBreadcrumbs = useSetBreadcrumbContext();

  const executeSearch = (
    argName: string,
    argPrefecture: string,
    argAge: number,
    argGraduated: string,
    argGuCode?: GradeUnitCode,
  ) => {
    // TODO: 検索条件をセッションに保存する
    setLoading(true);
    const temp: SearchEntryRacerInputParam = {
      racerName: argName,
      prefecture: argPrefecture,
      ageRange: argAge,
      gradeUnitCode: argGuCode,
      graduated: argGraduated,
    };
    setSearchParam(temp);
    loadSearchRacer({
      variables: {
        input: temp,
      },
    });
  };

  const clickRacerName = (argSortItem: string) => {
    fromScreenStorage.set('search');
    fromScreenUrlStorage.set(pathname);
    if (searchParam) {
      searchSortStorage.set(argSortItem);
      searchConditionStorage.set(searchParam);
    }
  };

  useEffect(() => {
    if (!searchRacerData.loading && searchRacerData) {
      setSearchResults(
        searchRacerData.data?.searchEntryRacer as SearchEntryRacerResult[],
      );
      setLoading(false);
    }
  }, [searchRacerData]);

  useEffect(() => {
    const tempCondition = searchConditionStorage.get();
    if (tempCondition) {
      setSearchParam(tempCondition);
      executeSearch(
        tempCondition.racerName,
        tempCondition.prefecture,
        tempCondition.ageRange,
        tempCondition.graduated,
        tempCondition.gradeUnitCode!,
      );
      setOpenConditionArea(false);
      searchConditionStorage.remove();
    }
    const tempSort = searchSortStorage.get();
    if (tempSort) {
      setSortItem(tempSort);
      searchSortStorage.remove();
    }
  }, []);

  const { setLayoutStyles } = useLayoutContext();
  useLayoutEffect(() => {
    setLayoutStyles({
      showBetButton: false,
    });
  }, []);

  useEffect(() => {
    setBreadcrumbs([
      {
        name: '選手検索',
        to: '',
      },
    ]);
  }, []);

  return (
    <>
      <Helmet
        meta={{
          robots: 'noindex',
        }}
      >
        <title>選手検索</title>
      </Helmet>
      <SearchRacerConditionTemplate
        loading={loading}
        openCondition={openConditionArea}
        defaultParam={searchParam}
        setOpenCondition={setOpenConditionArea}
        viewMatchDetail={executeSearch}
      />
      <SearchRacerResultTemplate
        loading={loading}
        searchResults={searchResults}
        defaultSort={sortItem}
        clickRacerName={clickRacerName}
      />
    </>
  );
};
export default SearchEntryRacerPage;
